import { MeasurementData } from '../stores';

export function rnd(num: number, decimals = 2) {
  const power = Math.pow(10, decimals);
  return Math.round((num + Number.EPSILON) * power) / power;
}

export function roundMeasurementData(data: MeasurementData) {
  const output = {
    BodyWeight: { ...data.BodyWeight, value: rnd(data.BodyWeight.value, 1) },
    FatPercentage: {
      ...data.FatPercentage,
      value: rnd(data.FatPercentage.value),
    },
    FatMass: {
      ...data.FatMass,
      value: rnd(data.FatMass.value),
    },
    MusclePercentage: {
      ...data.MusclePercentage,
      value: rnd(data.MusclePercentage.value),
    },
    MuscleMass: {
      ...data.MuscleMass,
      value: rnd(data.MuscleMass.value),
    },
    BodyMassIndex: {
      ...data.BodyMassIndex,
      value: rnd(data.BodyMassIndex.value, 1),
    },
    PhysicalFitness: {
      ...data.PhysicalFitness,
      value: rnd(data.PhysicalFitness.value, 0),
    },
    CardioFitness: data.CardioFitness,
    HeartStrength: data.HeartStrength,
    CardiovascularRisk: data.CardiovascularRisk,
    BloodPressureSystolic: {
      ...data.BloodPressureSystolic,
      value: rnd(data.BloodPressureSystolic.value, 0),
    },
    BloodPressureDiastolic: {
      ...data.BloodPressureDiastolic,
      value: rnd(data.BloodPressureDiastolic.value, 0),
    },
    Pulse: { ...data.Pulse, value: rnd(data.Pulse.value, 0) },
    StressLevel: data.StressLevel,
  };

  return output;
}
